(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var schemata = require('schemata')
//, validateIfSet = require('@clocklimited/validity-validate-if-set')
const required = require('@clocklimited/validity-required')
const email = require('@clocklimited/validity-email')

module.exports = function () {

  return schemata(
    { _id:
      { type: String
      }
    , enabled:
      { type: Boolean
      , defaultValue: true
      }
    , name:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , vat:
      { type: String
      }
    , contractName:
      { type: String
      }
    , website:
      { type: String
      }
    , description:
      { type: String
      }
    , musicPreference:
      { type: String
      }
    , tags:
      { type: String
      }
    , email1:
      { type: String
      , validators:
        { all: [ email ]
        }
      }
    , email2:
      { type: String
      // @todo: re-enable validation
      //, validators:
      //  { all: [ validateIfSet(email) ]
      //  }
      }
    , phone1:
      { type: String
        , validators:
        { all: [ required ]
        }
      }
    , phone2:
      { type: String
      }
    , fax1:
      { type: String
      }
    , fax2:
      { type: String
      }
    , addressLine1:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , addressLine2:
      { type: String
      }
    , postcode:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , city:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , country:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , contacts:
      { type: Array
      }
    , paymentTerms:
      { type: String
      }
    , blacklist:
      { type: Boolean
      , defaultValue: false
      }
    , blacklistHistory:
      { type: Array
      , defaultValue: function () { return [] }
      }
    , dateCreated:
      { type: Date
      , defaultValue: function () { return new Date() }
      }
    }
  )
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/service/promoter/schema.js","/components/service/promoter")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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